module.exports = __webpack_public_path__ + "static/about-banner2-d9b325cd23e9ec8f30d66797db15c43b.jpg";